export const getBrowserTimezone = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return timezone.length > 0 ? timezone : 'UTC'
  } catch {
    return 'UTC'
  }
}
